import React from 'react';
import { BookOpen, ArrowRight, FileText } from 'lucide-react';
import { Link } from 'react-router-dom';

const Guides = () => {
  return (
    <section id="guides" className="py-20 px-4 sm:px-6 lg:px-8">
      <div className="max-w-7xl mx-auto">
        <div className="glass-strong rounded-2xl p-8 md:p-12 border border-toxic-cyan/30 overflow-hidden relative">
          <div className="absolute top-0 right-0 w-64 h-64 bg-toxic-cyan/10 rounded-full blur-3xl -translate-y-1/2 translate-x-1/2"></div>
          
          <div className="relative z-10 grid md:grid-cols-2 gap-8 items-center">
            <div>
              <div className="inline-flex items-center gap-2 mb-4 px-4 py-2 glass rounded-full border border-toxic-cyan/30">
                <BookOpen className="w-5 h-5 text-toxic-cyan" />
                <span className="text-sm text-toxic-cyan font-semibold">Guides pratiques</span>
              </div>
              
              <h2 className="text-3xl md:text-4xl font-bold mb-4 text-white">
                Comment parier en ligne en France ?
              </h2>
              
              <p className="text-white/80 leading-relaxed mb-6">
                Parier en ligne en France est simple et sécurisé lorsque vous choisissez un opérateur agréé par l'ANJ. 
                Créez votre compte en quelques minutes, vérifiez votre identité, effectuez votre premier dépôt et 
                profitez des bonus de bienvenue. Nos guides détaillés vous accompagnent à chaque étape pour maximiser 
                vos chances de succès.
              </p>
              
              <p className="text-white/80 leading-relaxed mb-8">
                Découvrez nos conseils d'experts sur les stratégies de paris, la gestion de votre bankroll, 
                l'analyse des cotes et bien plus encore. Que vous débutiez ou que vous souhaitiez perfectionner 
                votre approche, nos ressources vous aideront à prendre des décisions plus éclairées.
              </p>
              
              <Link
                to="/guides"
                data-discover="true"
                className="inline-flex items-center gap-2 px-6 py-3 bg-gradient-to-r from-toxic-cyan to-toxic-green text-black font-bold rounded-lg hover:shadow-lg hover:shadow-toxic-cyan/50 transition-all"
              >
                <FileText className="w-5 h-5" />
                Consulter tous les guides
                <ArrowRight className="w-5 h-5" />
              </Link>
            </div>
            
            <div className="grid gap-4">
              <div className="glass rounded-lg p-4 border border-white/10 hover:border-toxic-cyan/50 transition-all">
                <h3 className="font-semibold text-white mb-2">Créer un compte</h3>
                <p className="text-sm text-white/70">Étapes simples pour ouvrir votre compte chez un opérateur agréé</p>
              </div>
              <div className="glass rounded-lg p-4 border border-white/10 hover:border-toxic-cyan/50 transition-all">
                <h3 className="font-semibold text-white mb-2">Comprendre les cotes</h3>
                <p className="text-sm text-white/70">Apprenez à lire et interpréter les cotes pour optimiser vos paris</p>
              </div>
              <div className="glass rounded-lg p-4 border border-white/10 hover:border-toxic-cyan/50 transition-all">
                <h3 className="font-semibold text-white mb-2">Gérer votre bankroll</h3>
                <p className="text-sm text-white/70">Stratégies pour gérer efficacement votre budget de paris</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Guides;

